"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["FormComponent", "validateOnBlur", "validate", "containerClassName", "errorClassName"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "error-message": "error-message_3oFsSw",
  "errorMessage": "error-message_3oFsSw"
}; 
require('./FormComponentWithValidation.css');
var FormComponentWithValidation = /*#__PURE__*/function (_Component) {
  function FormComponentWithValidation() {
    var _this;
    (0, _classCallCheck2.default)(this, FormComponentWithValidation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FormComponentWithValidation, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      isDirty: false
    });
    (0, _defineProperty2.default)(_this, "getErrors", function () {
      var _this$props = _this.props,
        value = _this$props.value,
        validate = _this$props.validate;
      return Object.values(validate).reduce(function (acc, curr) {
        var isValid = curr.validate({
          value: value
        });
        if (!isValid) {
          return [].concat((0, _toConsumableArray2.default)(acc), [curr.message]);
        }
        return acc;
      }, []);
    });
    (0, _defineProperty2.default)(_this, "handleBlur", function (event) {
      if (!_this.state.isDirty) {
        _this.setState({
          isDirty: true
        });
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(FormComponentWithValidation, _Component);
  return (0, _createClass2.default)(FormComponentWithValidation, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isDirty && !prevProps.isDirty && !this.state.isDirty) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isDirty: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isDirty = this.state.isDirty;
      var _this$props2 = this.props,
        FormComponent = _this$props2.FormComponent,
        validateOnBlur = _this$props2.validateOnBlur,
        validate = _this$props2.validate,
        containerClassName = _this$props2.containerClassName,
        errorClassName = _this$props2.errorClassName,
        formProperties = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var errors = isDirty ? this.getErrors() : [];
      var isValid = errors.length === 0;
      var errorLabel = "".concat(formProperties.id, "-error");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClassName
      }, /*#__PURE__*/_react.default.createElement(FormComponent, (0, _extends2.default)({}, formProperties, {
        "aria-describedby": isValid ? null : errorLabel,
        "aria-invalid": !isValid,
        onBlur: validateOnBlur ? this.handleBlur : undefined,
        isDirty: this.state.isDirty,
        isValid: isValid
      })), !isValid && /*#__PURE__*/_react.default.createElement("p", {
        id: errorLabel,
        className: (0, _classnames.default)(styles.errorMessage, errorClassName),
        role: "alert"
      }, errors[0]));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(FormComponentWithValidation, "propTypes", {
  validate: _propTypes.default.objectOf(_propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    validate: _propTypes.default.func.isRequired
  })).isRequired,
  FormComponent: _propTypes.default.any.isRequired,
  validateOnBlur: _propTypes.default.bool,
  isDirty: _propTypes.default.bool,
  value: _propTypes.default.string,
  errorClassName: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  onBlur: _propTypes.default.func
});
(0, _defineProperty2.default)(FormComponentWithValidation, "defaultProps", {
  validateOnBlur: false,
  errorClassName: ''
});
var _default = exports.default = FormComponentWithValidation;
//# sourceMappingURL=FormComponentWithValidation.js.map